export type IsoDate = string & { readonly __brand: 'IsoDate' }

export interface IsoDateParts {
  year: number
  month: number
  day: number
}

const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

export function isoDateParts(value: string): IsoDateParts {
  const match = ISO_DATE_PATTERN.exec(value)
  if (!match) throw new Error(`Date must use ISO yyyy-MM-dd format, received "${value}"`)
  const year = Number(match[1])
  const month = Number(match[2])
  const day = Number(match[3])
  const lastDay = month >= 1 && month <= 12
    ? new Date(Date.UTC(year, month, 0)).getUTCDate()
    : 0
  if (year < 1 || month < 1 || month > 12 || day < 1 || day > lastDay) {
    throw new Error(`Date must be a real calendar date, received "${value}"`)
  }
  return { year, month, day }
}

export function assertIsoDate(value: string): asserts value is IsoDate {
  isoDateParts(value)
}

export function toIsoDate(value: string): IsoDate {
  assertIsoDate(value)
  return value
}
